/* @flow */

const isDataBrasileira = (value: string) => /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(value);

export default isDataBrasileira;
